import React, { useRef, useEffect } from 'react';
import './Testimonials.css'
import Common_title from '../../common-components/common-title/Common_title'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuoteLeft } from '@fortawesome/free-solid-svg-icons';

const Testimonials = ({allreview}) => {
    const sliderRef = useRef(null);

    const settings = {
        dots: true,
        infinite: true,
        slidesToShow:3,
        slidesToScroll: 1,
        vertical: true,
        verticalSwiping: true,
        swipeToSlide: true,
        arrows: false,
    };



    useEffect(() => {
        const sliderContainer = document.querySelector('.slider-container');

        const handleWheel = (e) => {
            e.preventDefault();
            if (e.deltaY < 0) {
                sliderRef.current.slickPrev();
            } else {
                sliderRef.current.slickNext();
            }
        };

        if (sliderContainer) {
            sliderContainer.addEventListener('wheel', handleWheel);
        }

        return () => {
            if (sliderContainer) {
                sliderContainer.removeEventListener('wheel', handleWheel);
            }
        };
    }, []);

    return (
        <section className='Testimonials_section'>
            <div className='container'>
                <div className='row'>
                    <div className='col-lg-6 col-12 my-auto'>
                        <div className='testtitlediv'>
                            <Common_title titleblack={'What Our'} />
                            <Common_title title={'Customer Says'} />
                            <p className='testsubtitle'>
                                Our customers love the comfort, clarity, and style we deliver.
                                See what they’re saying about their experience.
                            </p>
                        </div>
                    </div>
                    <div className='col-lg-6 col-12 my-auto'>
                        <div className='slidersec'>
                            <div className="slider-container" style={{ overflow: 'hidden' }}>
                                <Slider ref={sliderRef} {...settings}>
                                    {allreview?.map((val)=>
                                    <div>
                                        <div className='slider_div'>
                                            <FontAwesomeIcon className='quouteicon' icon={faQuoteLeft} />
                                            <div className='flexdiv'>
                                                <div className='imgdiv'>
                                                    <img className='clientimg' src={process.env.PUBLIC_URL + '/assets/images/home/testimonials/client1.png'} />
                                                </div>
                                                <div className='contentdiv'>
                                                    <p className='client-name'>{val?.User?.name}</p>
                                                    <p className='content'>{val?.review} </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>)}

                                    {/* <div>
                                        <div className='slider_div'>
                                            <FontAwesomeIcon className='quouteicon' icon={faQuoteLeft} />
                                            <div className='flexdiv'>
                                                <div className='imgdiv'>
                                                    <img className='clientimg' src={process.env.PUBLIC_URL + '/assets/images/home/testimonials/client2.png'} />
                                                </div>
                                                <div className='contentdiv'>
                                                    <p className='client-name'>Dhanesh Sarpale</p>
                                                    <p className='content'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magnat </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div className='slider_div'>
                                            <FontAwesomeIcon className='quouteicon' icon={faQuoteLeft} />
                                            <div className='flexdiv'>
                                                <div className='imgdiv'>
                                                    <img className='clientimg' src={process.env.PUBLIC_URL + '/assets/images/home/testimonials/client1.png'} />
                                                </div>
                                                <div className='contentdiv'>
                                                    <p className='client-name'>Aditya Jagtap</p>
                                                    <p className='content'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magnat </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div className='slider_div'>
                                            <FontAwesomeIcon className='quouteicon' icon={faQuoteLeft} />
                                            <div className='flexdiv'>
                                                <div className='imgdiv'>
                                                    <img className='clientimg' src={process.env.PUBLIC_URL + '/assets/images/home/testimonials/client2.png'} />
                                                </div>
                                                <div className='contentdiv'>
                                                    <p className='client-name'>Akshay Patil</p>
                                                    <p className='content'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magnat </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <div className='slider_div'>
                                            <FontAwesomeIcon className='quouteicon' icon={faQuoteLeft} />
                                            <div className='flexdiv'>
                                                <div className='imgdiv'>
                                                    <img className='clientimg' src={process.env.PUBLIC_URL + '/assets/images/home/testimonials/client3.png'} />
                                                </div>
                                                <div className='contentdiv'>
                                                    <p className='client-name'>Omkar Shinde</p>
                                                    <p className='content'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magnat </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div> */}
                                    
                                </Slider>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Testimonials;
